const binding = { modules: {}, dataActions: {} };

    (binding.modules['business-sign-up'] = {
        c: () => require('partner/modules/business-sign-up/business-sign-up.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'business-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/business-sign-up'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|business-sign-up|business-sign-up'] = {
                c: () => require('partner/modules/business-sign-up/business-sign-up.view.tsx'),
                cn: '__local__-__local__-business-sign-up'
            };
viewDictionary['@msdyn365-commerce-modules|business-account-management|modules|business-sign-up|business-sign-up'] = {
                c: () => require('@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up/business-sign-up.view.js'),
                cn: '@msdyn365-commerce-modules-business-account-management-business-sign-up'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };